<template>
    <div>
        <template>
            <span v-if="data.column.field == 'relatedOrders'" ref="trigger">{{ data.relatedOrders }}</span>
            <span v-if="data.column.field == 'subStatusDeliveryState' && this.data.subStatusDeliveryState == true" style="color:green" ref="trigger">Ready</span>
            <span v-if="data.column.field == 'subStatusDeliveryState' && this.data.subStatusDeliveryState == false" style="color:red" ref="trigger">Not Ready</span>
            <b-popover :target="popoverTarget" triggers="hover" @show="onPopoverShow">
                <b-skeleton-wrapper :loading="!workItemOrders">
                    <template #loading>
                        <b-skeleton></b-skeleton>
                        <b-skeleton></b-skeleton>
                        <b-skeleton></b-skeleton>
                    </template>
                    <b-list-group>
                        <b-list-group-item v-for="(workItemOrder) in workItemOrders" :key="workItemOrder.order.orderId">
                            <div><strong>Order:</strong> {{ workItemOrder.order.orderNumberDisplayText }} </div>
                            <div v-if="data.column.field == 'relatedOrders'"><strong>Client ref: </strong>{{ renderClientReference(workItemOrder.clientReference) }}</div>
                            <div v-if="data.column.field == 'subStatusDeliveryState'">
                                <div v-html="renderSubStatusList(workItemOrder.order.subStatus.displayName)"></div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-skeleton-wrapper>
            </b-popover>
        </template>
    </div>
</template>

<script>
    import axios from 'axios';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import ErrorsMixin from '../../mixins/ErrorsMixin';

    export default {
        name: 'RelatedOrderClientReferencesColumnTemplate',
        mixins: [ErrorsMixin, DateTimeMixin],
        data: function () {
            return {
                data: null,
                workItemOrders: null,
            };
        },

        methods: {
            popoverTarget: function () {
                return this.$refs.trigger;
            },
            onPopoverShow: function () {
                if (this.workItemOrders === null) {
                    this.loadWorkItemOrders();
                }
            },
            loadWorkItemOrders: function () {
                var url = this.$urlHelper.getApiUrl('order', 'byworkitem', [this.data.workItemId, 'list']);
                console.log('in load workitem orders');
                axios
                    .get(url)
                    .then(response => {
                        this.workItemOrders = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },
            renderSubStatusList: function (subStatusDisplayName) {

                var subStatusArray = subStatusDisplayName.split(",");
                var subStatusList = '';
                                
                for (var i = 0; i < subStatusArray.length; i++) {
                    subStatusList += subStatusArray[i] + '<br />';
                }
                return subStatusList;
            },
            renderClientReference: function (clientReference) {

                if (clientReference) return clientReference
                else return '-- not stated --'
            }
        }
    }
</script>